import React, { useEffect } from "react";
import { useParams, Link, useNavigate } from 'react-router-dom';
import { CurrentUserContext } from '../../contexts/CurrentUserContext'
import './CardPage.css'
import {LanguageContext} from '../../contexts/TranslationContext'
import choose from '../../const/CardPageData'
import noPictures from '../../images/nopictures.png'
import { TbEdit } from "react-icons/tb";
import BackBtn from '../../UK-kit/BackBtn'
import { useFavorites } from "../../contexts/FavoritesContext"
import { useItemsContext } from "../../contexts/ItemsContext"
import Button from '../../UK-kit/Button/Button'
import Container from '../../UK-kit/Container/Container'

function CardPage({ openEditPopup, openDeletePopup, getItemById, addToFavorites, isLoggin, deleteFromFavorites, openFirstMessagePopup, openImgLinkPopup}) {
    let { item_id } = useParams();
    const currentUser = React.useContext(CurrentUserContext)
    const favorite_collector_id = currentUser.user_id

    const {
        selectedItem,
    } = useItemsContext();

    const {
        favorite, 
    } = useFavorites();

    const { language } = React.useContext(LanguageContext)

    const { en, rus, hebrew } = choose;
  
    let translatedContext = '';
    if (language === 'en') {
      translatedContext = en;
    } else if (language === 'rus') {
      translatedContext = rus;
    } else if (language === 'hebrew') {
      translatedContext = hebrew;
    }
    
    useEffect(() => {
        getItemById(item_id);

    }, []);

    if(selectedItem.length === 0) {
        return (  
        <div className="cardPage__centr-container">
            <p>Объявление не найдено или удалено.</p>
            <Button className="cardPage__info-about-user">
                <Link to={`/`} className="cardPage-link">Вернуться на главную страницу</Link>                       
            </Button>
        </div>
        );
    } 

    const conditionByLanguage = {
        rus: selectedItem[0]?.condition_ru,
        en: selectedItem[0]?.condition_en,
        hebrew: selectedItem[0]?.condition_he
    };

    const langKey = {
        rus: 'title_ru',
        en: 'title_en',
        hebrew: 'title_he'
    };

    const langDescriptionKey = {
        rus: 'description_ru',
        en: 'description_en',
        hebrew: 'description_he'
    };

    const langMap = {
        rus: 'city_ru',
        en: 'city_en',
        hebrew: 'city_he'
    };

    const langConditionMap = {
        rus: 'condition_ru',
        en: 'condition_en',
        hebrew: 'condition_he'
    };

    const langCategoryKey = {
        rus: 'parent_category_name_rus',
        en: 'parent_category_name',
        hebrew: 'parent_category_name_he'
    }
      
    const displayedCity = selectedItem[0][langMap[language]] || selectedItem[0].city;
    const displayedCondition = selectedItem[0][langConditionMap[language]] || selectedItem[0].condition;
    
    {/*const displayedCondition =
conditionByLanguage[language] || selectedItem[0]?.condition;*/}

    function hundleDeleteMyAd() {
        openDeletePopup(selectedItem[0].item_id)
    }

    function handleAddToFavorites() {
        addToFavorites(favorite_collector_id, selectedItem[0].item_id, selectedItem[0])
    }

    function hundleDeleteFromFavorites() {
        deleteFromFavorites(selectedItem[0])
    }

    function handleAddMessagePopupOpen() {
        openFirstMessagePopup(selectedItem[0].owner_id, selectedItem[0].item_id)
    }

    function handleOpenConditionEditPopup() {
        openEditPopup(selectedItem[0].item_id, "condition")
    }

    function handleOpenPriceEditPopup() {
        openEditPopup(selectedItem[0].item_id, "price")
    }

    function handleOpenCityEditPopup() {
        openEditPopup(selectedItem[0].item_id, "city")
    }

    function handleOpenDescriptionEditPopup() {
        openEditPopup(selectedItem[0].item_id, "description")
    }

    const isLiked = favorite.some((i) => i.item_id === selectedItem[0].item_id)
    return(
        <section className="cardPage-section">
            
            <div className="cardPage-main-container">
            {/*<section as='section'  className="cardPage-section">
            <div as='div' baseClassName='container' className="cardPage-main-container">*/}
                <BackBtn/>
                <div className="cardPage-container">

                <ul className="cardPage__main-pic-wrapper">
                    {selectedItem[0].images?
                        (
                            selectedItem[0].images.map((i, index) => (
                                <li key={index} className="cardPage__main-pic-container" onClick={() => openImgLinkPopup(i)}>
                                    <img className="cardPage__main-pic" alt = {selectedItem.title} src={i}></img>
                                </li>
                            ))
                        )
                    : 
                        <li className="cardPage__main-pic-wrapper">
                            <img className="cardPage__no-pic" alt = 'no pic' src={noPictures}></img>
                        </li>
                    }
                </ul>

                    <div className="cardPage-info-container">
                        <div className="cardPage-info-wrapper">
                            {selectedItem[0].reserved?
                                <Button className="cardPage-res-btn">Зарезервировано</Button>
                            :
                                <></>
                            }
                            <p className="cardPage-info-title">{translatedContext.name}: <span className="cardPage-info">{selectedItem[0][langKey[language]] || selectedItem[0].title}</span></p>
                            <p className="cardPage-info-title">{translatedContext.category}: <span className="cardPage-info">{selectedItem[0][langCategoryKey[language]] || selectedItem[0].parent_category_name}</span></p>
                            
                            {(
                                selectedItem[0].condition ||
                                selectedItem[0].condition_ru ||
                                selectedItem[0].condition_en ||
                                selectedItem[0].condition_he
                                ) ? (
                                <div className="cardPage-info-edit-container">
                                    {isLoggin && currentUser.user_id === selectedItem[0].owner_id ? (
                                    <button className="cardPage-edit-btn" onClick={handleOpenConditionEditPopup}>
                                        <TbEdit className="cardPage-edit-icon"/>
                                    </button>
                                    ) : null}

                                    <p className="cardPage-info-title">
                                    {translatedContext.condition}: 
                                    <span className="cardPage-info">{displayedCondition}</span>
                                    </p>
                                </div>
                                ) : null}

                            

                            <div className="cardPage-info-edit-container">
                                {isLoggin && currentUser.user_id === selectedItem[0].owner_id?
                                    <button className="cardPage-edit-btn" onClick={handleOpenPriceEditPopup}>
                                        <TbEdit className="cardPage-edit-icon"/>
                                    </button>
                                    :
                                    <></>
                                }
                                <p className="cardPage-info-title">{translatedContext.price}: <span className="cardPage-info">{selectedItem[0].price} ₪</span></p>
                            </div>

                            <div className="cardPage-info-edit-container">
                                {isLoggin && currentUser.user_id === selectedItem[0].owner_id?
                                    <button className="cardPage-edit-btn" onClick={handleOpenCityEditPopup}>
                                        <TbEdit className="cardPage-edit-icon"/>
                                    </button>
                                    :
                                    <></>
                                }
                                <p className="cardPage-info-title">{translatedContext.city}: <span className="cardPage-info">{displayedCity}</span></p>
                            </div>


                            <p className="cardPage-info-title">{translatedContext.seller}: <Link to={`/users/${selectedItem[0].owner_id}`} className="cardPage-link">{selectedItem[0].owner_name}</Link></p>
                            
                            {
                            isLoggin && currentUser.user_id === selectedItem[0].owner_id ?
                                <></>
                            :
                            <Button className="cardPage__info-about-user">
                                <Link to={`/users/${selectedItem[0].owner_id}`} className="cardPage-link">{translatedContext.seeAllUserAds} &rarr;</Link>                       
                            </Button>
                            }


                                {selectedItem[0].owner_telegram && selectedItem[0].owner_telegram !== currentUser.telegram && (
                                <Button as="a"
                                    className="cardPage__btn-container"
                                    href={`https://t.me/${selectedItem[0].owner_telegram.replace(/^@/, '').replace(/\s+/g, '')}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {translatedContext.btn.messageTheSellerOnTelegram}
                                </Button>
                                )}



                        </div>
                        {
                            isLoggin?
                                <div className="cardPage__btn-container">
                                    {currentUser.user_id === selectedItem[0].owner_id ?
                                        <>
                                        
                                        {/*<button className='cardPage__write-message-btn' onClick={hundleDeleteMyAd}>{translatedContext.deleteBtn}</button>*/}
                                        </>
                                    
                                    :
                                        <div className="cardPage__btn-container">
                                        {isLiked? 
                                    
                                           <Button onClick={hundleDeleteFromFavorites} >{translatedContext.btn.deleteFromFavBtn}</Button>
                                        :
                                           <Button onClick={handleAddToFavorites} >{translatedContext.btn.addToFavBtn}</Button>
                                        }
                                    
                                        <Button  onClick={handleAddMessagePopupOpen}>{translatedContext.btn.writeAMessageBtn}</Button>
                                        </div>
                                    }
                                </div>
                            :
                            <></>
                        }


                    </div>
                </div>
                {selectedItem[0].description.length <= 0 ? 
                 (
                    isLoggin && currentUser.user_id === selectedItem[0].owner_id?
                        <button className="cardPage-edit-btn-description" onClick={handleOpenDescriptionEditPopup}>
                            <TbEdit className="cardPage-edit-icon"/>
                            <p className="cardPage-add-description">{translatedContext.addDescription}</p>
                        </button>

                        :
                        <></>
                    
                 ) 
                :
                <div className="cardPage-description-container">
                    <div className="cardPage-info-edit-container">
                        {isLoggin && currentUser.user_id === selectedItem[0].owner_id?
                            <button className="cardPage-edit-btn-description" onClick={handleOpenDescriptionEditPopup}>
                                <TbEdit className="cardPage-edit-icon"/>
                            </button>
                            :
                            <></>
                        }
                        <p className="cardPage-info">{translatedContext.description}:</p>
                    </div>
                    <p className="cardPage-info-description">{selectedItem[0][langDescriptionKey[language]] || selectedItem[0].description}</p>
                </div>
                }
            </div>
        </section>
    );
}

export default CardPage;
